import { render } from "./RealestateDetailView.vue?vue&type=template&id=340e6e58"
import script from "./RealestateDetailView.vue?vue&type=script&lang=js"
export * from "./RealestateDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__